import React from 'react';
import { AdminLayout } from '.';
import { useHealthCheckQuery } from '@queries/index';

export const HealthCheck = () => {
    const { isLoading, data } = useHealthCheckQuery();

    return (
        <AdminLayout>
            {
                isLoading && <div>Verifying application health...</div>
            }
            {
                data && (
                    <table>
                        <thead>
                            <tr>
                                <th><strong>Application</strong></th>
                                <th><strong>Azure SQL DB</strong></th>
                                <th><strong>Redis</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{data.message}</td>
                                <td>{data.databaseConnection}</td>
                                <td>{data.redisConnection}</td>
                            </tr>
                        </tbody>
                    </table>
                )
            }
        </AdminLayout>
    );
};

export default HealthCheck;
